import { render } from "./ReviewManagement.vue?vue&type=template&id=1c09765c&scoped=true"
import script from "./ReviewManagement.vue?vue&type=script&lang=js"
export * from "./ReviewManagement.vue?vue&type=script&lang=js"

import "./ReviewManagement.vue?vue&type=style&index=0&id=1c09765c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c09765c"]])

export default __exports__